import { gql, useMutation } from "@apollo/client";

export const ADD_PMX_ACTIVITY_FAVORITE_MUTATION = gql`
  mutation addPmxActivityFavorite($id: ID!) {
    addPmxActivityFavorite(input: { id: $id })
  }
`;

export function useAddPmxActivityFavoriteMutation() {
  const [
    addPmxActivityFavorite,
    { loading: loadingAddFavoritesMutation, error: errorAddFavoritesMutation }
  ] = useMutation(ADD_PMX_ACTIVITY_FAVORITE_MUTATION);

  return {
    addPmxActivityFavorite,
    loadingAddFavoritesMutation,
    errorAddFavoritesMutation
  };
}
